/* @jsx glam */
import glam from "glam";
import React, {
    useState,
    useEffect,
    forwardRef,
    useImperativeHandle
} from "react";
import Carousel, { Modal, ModalGateway } from "react-images";

const Lightbox = forwardRef(({ images, currentModal }, ref) => {
    useImperativeHandle(ref, () => ({
        changeIndex(index) {
            setCurrentIndex(index);
        }
    }));

    const navButtonStyles = base => ({
        ...base,
        backgroundColor: "white",
        boxShadow: "0 1px 6px rgba(0, 0, 0, 0.18)",
        color: "#6B778C",

        "&:hover, &:active": {
            backgroundColor: "white",
            color: "#091E42",
            opacity: 1
        },
        "&:active": {
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.14)",
            transform: "scale(0.96)"
        },
        zIndex: 130
    });

    const [currentIndex, setCurrentIndex] = useState(null);

    useEffect(() => {
        setCurrentIndex(currentModal);
    }, [currentModal]);

    return (
        <ModalGateway>
            {Number.isInteger(currentIndex) ? (
                <Modal
                    allowFullscreen={false}
                    closeOnBackdropClick={false}
                    onClose={() => {
                        setCurrentIndex(null);
                    }}
                    styles={{
                        blanket: base => ({
                            ...base,
                            backgroundColor: "#000",
                            zIndex: 1250
                        }),
                        positioner: base => ({
                            ...base,
                            display: "block",
                            zIndex: 1260
                        })
                    }}
                >
                    <Carousel
                        currentIndex={currentIndex}
                        frameProps={{ autoSize: "height" }}
                        views={images}
                        styles={{
                            container: base => ({
                                ...base,
                                height: "100vh"
                            }),
                            view: base => ({
                                ...base,
                                alignItems: "center",
                                display: "flex ",
                                height: "calc(100vh - 54px)",
                                justifyContent: "center",
                                "& > img": {
                                    maxHeight: "calc(100vh - 94px)"
                                }
                            }),
                            navigationPrev: navButtonStyles,
                            navigationNext: navButtonStyles
                        }}
                    />
                </Modal>
            ) : null}
        </ModalGateway>
    );
});

export default Lightbox;
